/* Copyright (C) 2021 ev-i Informationstechnologie GmbH */

export enum ProjectAccess {
    INVISIBLE = "INVISIBLE",
    READ_ONLY = "READ_ONLY",
    READ_WRITE = "READ_WRITE",
    INVISIBLE_FORNONADMIN = "INVISIBLE_FORNONADMIN",
    READ_ONLY_FORNONADMIN = "READ_ONLY_FORNONADMIN"   
}
